import React, { Component } from 'react';
import { View, StyleSheet, Switch, TouchableOpacity, Platform, Button } from 'react-native';
import { connect } from 'react-redux';

import { Ionicons } from '@expo/vector-icons';
import Modal from 'react-native-modalbox';
import Color from 'react-native-material-color';
// import ActionSheet from 'react-native-actionsheet';

import * as actions from '../actions/settings.js';
import * as Styles from '../utils/Styles';
import * as Commons from '../utils/Commons';
import * as Constants from '../utils/Constants';
import { STRINGS } from '../utils/Strings';

import Header from '../components/Header';
import Text from '../components/Text';

class Settings extends Component {
    constructor(props) {
        super(props);

        this._weekDays = [
            STRINGS.sunday,
            STRINGS.monday,
            STRINGS.tuesday,
            STRINGS.wednesday,
            STRINGS.thursday,
            STRINGS.friday,
            STRINGS.saturday
        ];
        this._reminderASOptions = [STRINGS.every_other_day, STRINGS.every_week, STRINGS.custom_reminder, STRINGS.cancel];
    }

    async UNSAFE_componentWillMount() {
        const recNewsInfo = (await Commons.getFromAS(Constants.recNewsInfo)) !== Constants.FALSE_STR;
        const invByEmail = (await Commons.getFromAS(Constants.invByEmail)) !== Constants.FALSE_STR;
        let reminder = await Commons.getFromAS(Constants.reminder);
        if (reminder == null) {
            reminder = Constants.EVERY_WEEK;
        } else {
            reminder = parseInt(reminder);
        }
        const customReminderDays = await this.getSavedCustomReminderDays();
        this.props.updateState({ recNewsInfo, invByEmail, reminder, customReminderDays });
    }

    componentWillUnmount() {
        this.props.resetState();
    }

    render() {
        const { recNewsInfo, invByEmail, reminder } = this.props;
        return (
            <View style={styles.container}>
                <Header title={STRINGS.company_name} leftView={Styles.drawerButtonDark(this.props.navigation)} light={true}  navigation={this.props.navigation} />
                {Styles.renderVSeparator(Commons.isIphoneX && Commons.isIphoneX() ? 80 : Platform.select({ ios: 68, android: 68 }))}
                {this.renderSwitchSetting(STRINGS.news_info_title, STRINGS.news_info_desc, recNewsInfo, this.toggleRecNewsInfo)}
                {this.renderSwitchSetting(STRINGS.inv_by_mail_title, STRINGS.inv_by_mail_desc, invByEmail, this.toggleInvByEmail)}

                {/* Reminder */}
                <TouchableOpacity style={styles.row} onPress={() => this.reminderAS.show()}>
                    <Text style={styles.title}>{STRINGS.reminder_title}</Text>
                    {Styles.renderVSeparator(12)}
                    <View style={styles.descView}>
                        <Text style={styles.desc}>{STRINGS.reminder_desc}</Text>
                        <Text style={styles.normal}>{this.getReminderName(reminder)}</Text>
                    </View>
                </TouchableOpacity>

                {/* Custom reminder week days modal */}
                <Modal
                    ref={el => (this.weekDaysModal = el)}
                    style={Styles.modal}
                    position={'center'}
                    animationDuration={250}
                    entry="bottom"
                    backButtonClose
                    onClosed={this.resetCustomDays}
                >
                    <View style={Styles.modalView}>
                        {this._weekDays.map((day, index) => (
                            index !== 5 && <TouchableOpacity style={styles.dayRow} key={day} onPress={() => this.toggleDay(index)}>
                                <Text style={styles.dayTxt}>{day}</Text>
                                {this.props.customReminderDays.indexOf(index) !== -1 && (
                                    <Ionicons name="md-checkmark" size={20} color="black" />
                                )}
                            </TouchableOpacity>
                        ))}
                        {Styles.renderVSeparator(12)}
                        <View style={Styles.modalBtnsView}>
                            <Button
                                color={Color.GREY[500]}
                                onPress={() => {
                                    this.weekDaysModal.close();
                                    this.reminderAS.show();
                                }}
                                title={STRINGS.cancel}
                            />
                            {Platform.OS === 'android' && Styles.renderSeparator(12)}
                            <Button
                                style={Platform.OS === 'android' && { marginLeft: 8 }}
                                onPress={async () => {
                                    this.weekDaysModal.close();
                                    this.props.updateState({ reminder: Constants.CUSTOM_REMINDER });
                                    await Commons.saveToAS(Constants.reminder, `${Constants.CUSTOM_REMINDER}`);
                                    await Commons.saveToAS(Constants.customReminderDays, JSON.stringify(this.props.customReminderDays));
                                    Commons.schedualReminders();
                                }}
                                title={STRINGS.apply}
                            />
                        </View>
                    </View>
                </Modal>

                {/* <ActionSheet
                    ref={el => (this.reminderAS = el)}
                    title={STRINGS.reminder}
                    options={this._reminderASOptions}
                    cancelButtonIndex={3}
                    onPress={async index => {
                        if (index === Constants.CUSTOM_REMINDER) {
                            this.weekDaysModal.open();
                            return;
                        }
                        if (index !== 3) {
                            this.props.updateState({ reminder: index });
                            await Commons.saveToAS(Constants.reminder, `${index}`);
                            Commons.schedualReminders();
                        }
                    }}
                /> */}
            </View>
        );
    }

    renderSwitchSetting = (title, desc, value, onToggle) => (
        <View style={styles.row}>
            <Text style={styles.title}>{title}</Text>
            {Styles.renderVSeparator(12)}
            <View style={styles.descView}>
                <Text style={styles.desc}>{desc}</Text>
                <Switch style={styles.switch} value={value} onValueChange={onToggle} />
            </View>
        </View>
    );

    toggleRecNewsInfo = value => {
        this.props.toggleRecNewsInfo(value);
    };

    toggleInvByEmail = value => {
        this.props.updateState({ invByEmail: value });
        Commons.saveToAS(Constants.invByEmail, value ? Constants.TRUE_STR : Constants.FALSE_STR);
    };

    getReminderName = key => {
        switch (key) {
            case Constants.EVERY_OTHER_DAY:
                return STRINGS.every_other_day;
            case Constants.EVERY_WEEK:
                return STRINGS.every_week;
            case Constants.CUSTOM_REMINDER:
                return STRINGS.custom_reminder;
            default:
                break;
        }
    };

    toggleDay = day => {
        const customReminderDays = this.props.customReminderDays.slice();
        const index = customReminderDays.indexOf(day);
        if (index === -1) {
            customReminderDays.push(day);
            customReminderDays.sort();
        } else {
            customReminderDays.splice(index, 1);
        }
        this.props.updateState({ customReminderDays });
    };

    getSavedCustomReminderDays = async () => {
        let customReminderDays = await Commons.getFromAS(Constants.customReminderDays);
        if (customReminderDays != null) {
            customReminderDays = JSON.parse(customReminderDays);
        } else {
            customReminderDays = [];
        }
        return customReminderDays;
    };

    resetCustomDays = async () => {
        const customReminderDays = await this.getSavedCustomReminderDays();
        this.props.updateState({ customReminderDays });
    };
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: Color.GREY[200]
    },
    row: {
        padding: 12,
        backgroundColor: 'white',
        borderBottomWidth: StyleSheet.hairlineWidth,
        borderColor: Color.GREY[500]
    },
    title: {
        fontSize: 18,
        color: '#ed9c26'
    },
    descView: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    desc: {
        fontSize: 16,
        color: '#6b3529',
        flex: 0.85
    },
    normal: {
        fontSize: 16,
        color: '#6b3529'
    },
    dayTxt: {
        fontSize: 17,
        color: Color.GREY[800]
    },
    switch: {
        flex: 0.15
    },
    dayRow: {
        width: '100%',
        padding: 12,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: 'white',
        borderBottomWidth: StyleSheet.hairlineWidth,
        borderColor: Color.GREY[300]
    }
});

const mapStateToProps = ({ settings }) => settings;

export default connect(
    mapStateToProps,
    actions
)(Settings);
